const API_URL = 'https://dev-api.skilldukez.com';

export const environment = {
    production: false,
    pusherClientSecret: '1503a7041ccdda0d20cb',
    dashboardApiURL: `${API_URL}/dashboard`,
    auth: {
        secureApiPaths: ['*'],
        config: {
            domain: 'dukez-dev.us.auth0.com',
            clientId: 'ajdWw5p57WyqXzqIOoVcnWjVK2PamqR7'
        }
    }
};
